import React, { useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { usePermission } from '@tomfxs/permissions-client'

import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const TrainingVideoUpdateForm = React.lazy(() => loadComponent('traiwiss', 'TrainingVideoUpdateForm'))

export function TrainingVideoUpdateFormRoute() {
    const params = useParams()
    const navigate = useNavigate()
    const { academy } = useFlightDeck()

    const canUpdate = usePermission('traiwiss.training.update', { academy: academy?._id! })
    const canDelete = usePermission('traiwiss.training.delete', { academy: academy?._id! })

    const onDelete = useCallback(() => {
        navigate('/training-videos')
    }, [navigate])

    const onUpdate = useCallback(() => {
        navigate('/training-videos')
    }, [navigate])

    return (
        <RouteContainer>
            <TrainingVideoUpdateForm _id={params._id} canDelete={canDelete} canUpdate={canUpdate} onDelete={onDelete} onUpdate={onUpdate} />
        </RouteContainer>
    )
}
